import { render, staticRenderFns } from "./VinculoEmpresas.vue?vue&type=template&id=45f1b64a&"
import script from "./VinculoEmpresas.vue?vue&type=script&lang=js&"
export * from "./VinculoEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./VinculoEmpresas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports